import { Alert } from '@mui/material';
import React from 'react';
import { EditorBaseImageSettings } from '../../editorBase';

const EditorTOTPImageSettings = () => (
	<div>
		<Alert severity="info" icon={false}>
			{intl.tr('screenEditor.settings.totp.image.hint')}
		</Alert>
		<EditorBaseImageSettings />
	</div>
);

export { EditorTOTPImageSettings };
